/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Capri API
 * OpenAPI spec version: 1.0.0
 */
import { adapter } from './adapter';
export interface HotelResponse {
  id: string;
  masterData: MasterData;
  /**
   * List of former names of the hotel
   * @nullable
   */
  formerName?: string | null;
  /** source of the description (Invia, GiataDrive etc) */
  descriptionSource?: string;
  description?: Description;
  inviaAttributes?: InviaAttributes[];
  supplierAttributes?: SupplierAttributes;
  reviews?: Reviews;
  biRank?: number;
  imagesCount: number;
  tourOperators?: TourOperator[];
  offers?: string[];
}

export interface MasterData {
  name: string;
  chainName?: string;
  category?: HotelCategory;
  address?: HotelAddress;
  contact?: HotelContact;
  coordinates?: Coordinates;
  location?: GiataLocation;
  greenCertificate?: GreenCertificate;
}

export interface GreenCertificate {
  /** Number of leaves (e.g. "3 Leafs") */
  leaves?: string;
  /** Renewal date (e.g. "2024-01-01") */
  renewalDate?: string;
  /** Name of the certification (e.g. "Green Globe") */
  certification?: string;
}

export interface GiataLocation {
  /** ISO city code (e.g., "CITY123") */
  cityCode?: string;
  /** Name of the city in the specified language */
  cityName?: string;
  /** ISO country code (e.g., "DE", "SC") */
  countryCode?: string;
  /** Name of the country in the specified language */
  countryName?: string;
  /** ISO region code (e.g., "REG456") */
  regionCode?: string;
  /** Name of the region in the specified language */
  regionName?: string;
}

export interface CountryCodeTranslation {
  /**
   * ISO country code (e.g., "DE", "EG")
   * @nullable
   */
  code: string | null;
  /**
   * Translated country name based on the specified language
   * @nullable
   */
  name: string | null;
}

export interface InviaAttribute {
  /**
   * Name of the hotel attribute
   * @nullable
   */
  name?: string | null;
  /**
   * Code representing the hotel attribute
   * @nullable
   */
  code?: string | null;
  /**
   * Value of the hotel attribute
   * @nullable
   */
  value?: string | null;
}

export interface InviaAttributes {
  /**
   * Attribute code
   * @nullable
   */
  code: string | null;
  /**
   * Translated attribute name based on the specified language
   * @nullable
   */
  name: string | null;
  /** Hotel Attributes */
  attributes?: InviaAttribute[];
}

export type SupplierAttributes = SupplierAttributeSection[];

export interface SupplierAttributeSection {
  name?: string;
  amenities?: SupplierAttributeAmenity[];
  sub_sections?: SupplierAttributeSection[];
}

export interface SupplierAttributeAmenity {
  id?: string;
  name?: string;
  attributes?: SupplierAttributeAmenityAttribute[];
}

export interface SupplierAttributeAmenityAttribute {
  value?: string;
  type?: string;
}

export interface HotelCategory {
  value?: number;
  categoryType?: string;
}

export interface HotelAddress {
  street?: string;
  streetNo?: string;
  zipCode?: string;
  cityName?: string;
  poBox?: string;
  stateName?: string;
  countryName?: string;
  countryCode: string;
}

export interface HotelContact {
  phone?: string;
  fax?: string;
  email?: string;
  www?: string;
}

export interface Coordinates {
  lat: number;
  lon: number;
}

export type Description = DescriptionSection[];

export interface DescriptionSection {
  /**
   * Title of the description section
   * @nullable
   */
  title: string | null;
  /**
   * Content of the description section
   * @nullable
   */
  description: string | null;
}

export interface Reviews {
  /** @nullable */
  count: number | null;
  /** @nullable */
  rating: number | null;
  /** @nullable */
  recommendation: number | null;
}

export interface TourOperator {
  /** */
  name: string;
  codes: string[];
}

export type ImageCategoriesItem = typeof ImageCategoriesItem[keyof typeof ImageCategoriesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageCategoriesItem = {
  exterior: 'exterior',
  interior: 'interior',
  room: 'room',
  restaurant: 'restaurant',
  pool: 'pool',
  beach: 'beach',
  sport: 'sport',
  others: 'others',
  unknown: 'unknown',
} as const;

/**
 * Image object containing hotel images.
 */
export interface Image {
  /** URL of the image. (with simple placeholders for {width} and {height} ) */
  url: string;
  /** Type of the image. */
  categories?: ImageCategoriesItem[];
  /** Width of the image. */
  width?: number;
  /** Height of the image. */
  height?: number;
}

export interface Text {
  /** Language of the translation. */
  lang: string;
  /** Translated text in UTF-8. */
  text: string;
}

export interface HotelDescriptionResponse {
  description: Text;
  translation?: Text;
  /** Hotel name from tour operator. */
  hotelName?: string;
  /** Hotel category from tour operator. */
  hotelCategory?: string;
}

export interface HotelFullDetailsResponse {
  description: Text;
  translation?: Text;
  /** Hotel name from tour operator. */
  hotelName?: string;
  /** Hotel category from tour operator. */
  hotelCategory?: string;
  images: Image[];
}

export interface Error {
  code: number;
  message: string;
}

/**
 * CRS code of the hotel.
 */
export type ServiceCodeParameter = string;

/**
 * Code identifying the tour operator.
 */
export type TourOperatorParameter = string;

/**
 * ID or code of the hotel (Giata ID).
 */
export type HotelParameter = string;

/**
 * Start date of the journey.
 */
export type DateMinParameter = string;

/**
 * End date of the journey.
 */
export type DateMaxParameter = string;

export type TravelTypeParameter = typeof TravelTypeParameter[keyof typeof TravelTypeParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TravelTypeParameter = {
  P: 'P',
  H: 'H',
  M: 'M',
  U: 'U',
} as const;

/**
 * Desired language of the catalog description.
 */
export type LangParameter = string;

export type GetHotelByIDParams = {
/**
 * Client identifier (e.g., `invia.cz`, `invia.sk`, `invia.hu`, `travelplanet.pl`, `wakacyjnipiraci.travelplanet.pl`, `AIDU.de`, `AIDU.at`, `AIDU.ch`, `reisegeier.de`, `reisegeier.at`, `reisegeier.ch`)
 */
clientID?: GetHotelByIDClientID;
/**
 * A comma-separated list of top-level fields in `HotelResponse` that should be omitted from the response.

 */
fieldFilter?: GetHotelByIDFieldFilterItem[];
};

export type GetHotelByIDClientID = typeof GetHotelByIDClientID[keyof typeof GetHotelByIDClientID];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetHotelByIDClientID = {
  inviacz: 'invia.cz',
  inviask: 'invia.sk',
  inviahu: 'invia.hu',
  travelplanetpl: 'travelplanet.pl',
  wakacyjnipiracitravelplanetpl: 'wakacyjnipiraci.travelplanet.pl',
  AIDUde: 'AIDU.de',
  AIDUat: 'AIDU.at',
  AIDUch: 'AIDU.ch',
  reisegeierde: 'reisegeier.de',
  reisegeierat: 'reisegeier.at',
  reisegeierch: 'reisegeier.ch',
} as const;

export type GetHotelByIDFieldFilterItem = typeof GetHotelByIDFieldFilterItem[keyof typeof GetHotelByIDFieldFilterItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetHotelByIDFieldFilterItem = {
  description: 'description',
  inviaAttributes: 'inviaAttributes',
  supplierAttributes: 'supplierAttributes',
} as const;

export type GetV1DescriptionParams = {
/**
 * CRS code of the hotel.
 */
serviceCode: ServiceCodeParameter;
/**
 * Code identifying the tour operator.
 */
tourOperator: TourOperatorParameter;
/**
 * ID or code of the hotel (Giata ID).
 */
hotel?: HotelParameter;
/**
 * Start date of the journey.
 */
dateMin: DateMinParameter;
/**
 * End date of the journey.
 */
dateMax: DateMaxParameter;
/**
 * Type of travel (e.g., package = P, ownArrival = H, mixed = M, U = unknown).
 */
travelType?: TravelTypeParameter;
/**
 * Desired language of the catalog description.
 */
lang?: LangParameter;
};

export type GetV1FullDetailsParams = {
/**
 * CRS code of the hotel.
 */
serviceCode: ServiceCodeParameter;
/**
 * Code identifying the tour operator.
 */
tourOperator: TourOperatorParameter;
/**
 * ID or code of the hotel (Giata ID).
 */
hotel?: HotelParameter;
/**
 * Start date of the journey.
 */
dateMin: DateMinParameter;
/**
 * End date of the journey.
 */
dateMax: DateMaxParameter;
/**
 * Type of travel (e.g., package = P, ownArrival = H, mixed = M, U = unknown).
 */
travelType?: TravelTypeParameter;
/**
 * Desired language of the catalog description.
 */
lang?: LangParameter;
};

/**
 * Retrieve detailed information about a specific hotel using its GiataID.

### Supported Clients
- **Client Identifiers (clientID):**
  `invia.cz`, `invia.sk`, `invia.hu`, `travelplanet.pl`, `wakacyjnipiraci.travelplanet.pl`, 
  `AIDU.de`, `AIDU.at`, `AIDU.ch`, `reisegeier.de`, `reisegeier.at`, `reisegeier.ch`
### Language Mapping
Language is automatically derived from the provided `clientID` as follows:
  - `invia.cz` → **cs** (Czech)
  - `invia.sk` → **sk** (Slovak)
  - `invia.hu` → **hu** (Hungarian)
  - `travelplanet.pl` → **pl** (Polish)
  - `wakacyjnipiraci.travelplanet.pl` → **pl** (Polish)
  - `AIDU.de` → **de** (German)
  - `AIDU.at` → **de** (German)
  - `AIDU.ch` → **de** (German)
  - `reisegeier.de` → **de** (German)
  - `reisegeier.at` → **de** (German)
  - `reisegeier.ch` → **de** (German)
- **Default Language:** `English`

### Examples
```bash
# Get hotel details for invia.cz (default client, language: Czech)
curl "http://localhost:8080/v1/hotels/100004?clientID=invia.cz"

# Get hotel details for AIDU.de (language: German)
curl "http://localhost:8080/v1/hotels/100004?clientID=AIDU.de"

# Get hotel details for travelplanet.pl (language: Polish),
# excluding the description, inviaAttributes, and supplierAttributes fields
curl "http://localhost:8080/v1/hotels/12?clientID=travelplanet.pl&fieldFilter=description,inviaAttributes,supplierAttributes"

 * @summary Get a hotel by ID
 */
export type getHotelByIDResponse200 = {
  data: HotelResponse
  status: 200
}

export type getHotelByIDResponse400 = {
  data: Error
  status: 400
}
    
export type getHotelByIDResponseComposite = getHotelByIDResponse200 | getHotelByIDResponse400;
    
export type getHotelByIDResponse = getHotelByIDResponseComposite & {
  headers: Headers;
}

export const getGetHotelByIDUrl = (hotelID: string,
    params?: GetHotelByIDParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/hotels/${hotelID}?${stringifiedParams}` : `/v1/hotels/${hotelID}`
}

export const getHotelByID = async (hotelID: string,
    params?: GetHotelByIDParams, options?: RequestInit): Promise<getHotelByIDResponse> => {
  
  return adapter<getHotelByIDResponse>(getGetHotelByIDUrl(hotelID,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Retrieve the hotel description based on query parameters.
 * @summary Fetch Hotel Description
 */
export type getV1DescriptionResponse200 = {
  data: HotelDescriptionResponse
  status: 200
}

export type getV1DescriptionResponse400 = {
  data: void
  status: 400
}
    
export type getV1DescriptionResponseComposite = getV1DescriptionResponse200 | getV1DescriptionResponse400;
    
export type getV1DescriptionResponse = getV1DescriptionResponseComposite & {
  headers: Headers;
}

export const getGetV1DescriptionUrl = (params: GetV1DescriptionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/description?${stringifiedParams}` : `/v1/description`
}

export const getV1Description = async (params: GetV1DescriptionParams, options?: RequestInit): Promise<getV1DescriptionResponse> => {
  
  return adapter<getV1DescriptionResponse>(getGetV1DescriptionUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Retrieve extended hotel data such as name, category, and images.
 * @summary Fetch Basic Hotel Information
 */
export type getV1FullDetailsResponse200 = {
  data: HotelFullDetailsResponse
  status: 200
}

export type getV1FullDetailsResponse400 = {
  data: void
  status: 400
}
    
export type getV1FullDetailsResponseComposite = getV1FullDetailsResponse200 | getV1FullDetailsResponse400;
    
export type getV1FullDetailsResponse = getV1FullDetailsResponseComposite & {
  headers: Headers;
}

export const getGetV1FullDetailsUrl = (params: GetV1FullDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/full-details?${stringifiedParams}` : `/v1/full-details`
}

export const getV1FullDetails = async (params: GetV1FullDetailsParams, options?: RequestInit): Promise<getV1FullDetailsResponse> => {
  
  return adapter<getV1FullDetailsResponse>(getGetV1FullDetailsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
